import { render, staticRenderFns } from "./ChainInfo.vue?vue&type=template&id=bd8991ac&scoped=true&"
import script from "./ChainInfo.vue?vue&type=script&lang=js&"
export * from "./ChainInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChainInfo.vue?vue&type=style&index=0&id=bd8991ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8991ac",
  null
  
)

export default component.exports